import { createSlice } from '@reduxjs/toolkit';
import { IUser } from '@Data/users/Interfaces';
import { RootState } from '@Services/redux/Store';
import { initialAdminState } from './State';

const AdminSlice = createSlice({
    name: 'Admin',
    initialState: initialAdminState,
    reducers: {
        setIsUserSuperAdmin(state, action) {
            state.isUserSuperAdmin = action.payload;
        },
        setSuperAdmins(state, action) {
            state.superAdministrators = action.payload;
        },
    },
});

export const AdminActions = AdminSlice.actions;
export const settingsSuperAdminsState = (state: RootState): IUser[] =>
    state.admin.superAdministrators; // change to settingsUsersState
export const isUserSuperAdminState = (state: RootState): boolean =>
    state.admin.isUserSuperAdmin;

export default AdminSlice.reducer;
